import type { SxProps } from '@mui/material'

export default {
  table: {
    background: 'var(--ps-primary_bg)',
    border: '1px solid rgba(191, 255, 11, 0.2)',
  },
  head: {
    opacity: 0.7,
    backgroundColor: '#292b1d',
  },
  body: {},
} as Record<string, SxProps>
